import { render } from "./Radio.vue?vue&type=template&id=45a977e2"
import script from "./Radio.vue?vue&type=script&lang=js"
export * from "./Radio.vue?vue&type=script&lang=js"

import "./Radio.vue?vue&type=style&index=0&id=45a977e2&lang=scss"
script.render = render

export default script